import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d3c1893"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-center" }
const _hoisted_2 = { class: "text-center my-8 text-styled" }
const _hoisted_3 = {
  key: 0,
  class: "text-black-light-2 text-center my-6"
}
const _hoisted_4 = {
  key: 1,
  class: "text-black-light-2 text-center my-6"
}
const _hoisted_5 = { class: "d-flex justify-center area-btns" }

import { withDefaults, ref } from 'vue';
import { MoleculeModal } from '.';
import * as comps from '@/components/atoms';

interface IProps {
  icon?: string;
  text?: string;
  description?: string;
  iconColor?: string;
  showAlertConfirm: boolean;
  isText?: boolean;
  label?: string;
  textConfirmButton?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeModalAlert',
  props: {
    icon: {},
    text: {},
    description: {},
    iconColor: {},
    showAlertConfirm: { type: Boolean },
    isText: { type: Boolean, default: false },
    label: {},
    textConfirmButton: {}
  },
  emits: ['cancel', 'confirm'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const reason = ref<string>('');
const emit = __emit;

function handleCancel() {
  emit('cancel');
}

function handleConfirm() {
  emit('confirm', reason);
}

return (_ctx: any,_cache: any) => {
  const _component_v_textarea = _resolveComponent("v-textarea")!

  return (_openBlock(), _createBlock(_unref(MoleculeModal), {
    "padding-y": "70px",
    width: "390px",
    onHandleCancel: handleCancel,
    title: "Logout",
    showHeader: false,
    showFooter: false,
    persistent: false,
    show: _ctx.showAlertConfirm,
    "btn-close-text": "Cancelar"
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          (props.icon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(comps[props.icon]), {
                key: 0,
                color: props.iconColor
              }, null, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("p", _hoisted_2, [
          _createElementVNode("strong", null, _toDisplayString(props.text), 1)
        ]),
        (props.description)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(props.description), 1))
          : _createCommentVNode("", true),
        (props.isText)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
              _createVNode(_component_v_textarea, {
                label: props.label,
                modelValue: reason.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reason).value = $event))
              }, null, 8, ["label", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(comps.AtomButton, {
            onClick: handleCancel,
            classes: "btn-cancel btn-size",
            "prepend-icon": true,
            text: "Voltar"
          }),
          _createVNode(comps.AtomButton, {
            onClick: handleConfirm,
            classes: "btn-confirm btn-size",
            text: props.textConfirmButton || 'Sim'
          }, null, 8, ["text"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})